import { appAPI } from '@/api'
import { authAPI } from '@/api'

import { useUserStore } from '@/stores/user.js'


export async function getUsers()
{ 
  const response = await appAPI.get("/users/");
  return response.data;
}

export async function getUser( id )
{ 
  const response = await appAPI.get(`/users/${id}/`);
  return response.data;
}

export async function getProfiles()
{ 
  const response = await appAPI.get("/profiles/");
  return response.data;
}

export async function updateProfile()
{ 
  const userStore = useUserStore()
  let profile = {}
  profile.address = userStore.profile.address
  profile.phone = userStore.profile.phone
  const response = await appAPI.patch(`/profiles/${userStore.data.id}/`, profile );
  userStore.profile = response.data
  clearProfileCache(userStore.data.id)
}

export async function getMembers()
{ 
  const response = await appAPI.get("/members/");
  return response.data;
}

/** In-memory cache for roles (rarely change, loaded from multiple components) */
let _rolesCache = null

export async function getRoles()
{
  if (_rolesCache) return _rolesCache
  const response = await appAPI.get("/roles/");
  _rolesCache = response.data
  return _rolesCache
}

/** In-memory cache for profiles (Map<id, Promise>) - avoids redundant API calls */
const _profileCache = new Map()

/**
 * Clear the profile cache.
 * @param {number} [id] - If provided, only the cache entry for this ID is cleared.
 *                         If omitted, the entire cache is cleared.
 */
export function clearProfileCache(id) {
  if (id !== undefined && id !== null) {
    _profileCache.delete(id)
  } else {
    _profileCache.clear()
  }
}

export function getProfile(id) {
  if (_profileCache.has(id)) {
    return _profileCache.get(id)
  }
  const promise = appAPI.get(`/profiles/${id}/`).then(res => res.data)
  _profileCache.set(id, promise)
  // Remove cache entry on error so subsequent callers can retry
  promise.catch(() => { _profileCache.delete(id) })
  return promise
}

export async function getMemberRoles( id )
{ 
  const response = await appAPI.get(`/members/${id}/roles/`);
  return response.data;
}

export async function setMemberRoles( id, roles )
{ 
  const response = await appAPI.post(`/members/${id}/roles/`, { 'roles': roles });
  return response.data;
}

export async function getUserData()
{ 
  const response = await authAPI.get("/users/me");
  return response.data;
}

export async function updatePassword(currentPass,newPass)
{ 
  const response = await authAPI.post("/users/set_password/", {
  'current_password': currentPass,
  'new_password': newPass
  })
  return response.data;
}

export async function storePermissions()
{ 
  const  userStore = useUserStore()
  const response = await appAPI.get("/permissions/");
  userStore.permissions = response.data
}

export async function storeUserProfile()
{ 
  const userStore = useUserStore()
  const response = await appAPI.get(`/profiles/${userStore.data.id}/`);
  userStore.profile = response.data
}

export async function updateAvatar(avatar)
{ 
  const userStore = useUserStore()
  const form = new FormData()
  form.append('avatar', avatar, 'new_avatar.png')
  const response = await appAPI.patch(`/profiles/${userStore.data.id}/`, form );
  userStore.profile = response.data
  clearProfileCache(userStore.data.id)
}

export function hasPermission(permission)
{
  const  userStore = useUserStore()
  return userStore.permissions.includes(permission)
}
